export {
  TAB_STATUS_CONS,
  TAB_STATUS_DONE,
  TAB_STATUS_TODO,
} from '../ViewControls';

export const TRANSITION_TIMEOUT = 500;
export const MINIMUM_LENGTH_OF_COMMENT = 2;
export const ACTIONKEY_FOR_PREDEFINED_COMMENTS = 'REVIEWANDSUBMIT';
export const STEP1_CATEGORY_DECISION = 'decision';
export const STEP1_CATEGORY_TYPE = 'type';
export const STEP1_CATEGORIES = [STEP1_CATEGORY_DECISION, STEP1_CATEGORY_TYPE];
export const PRIMARY_CERTIFIER = 'primary_certifier';
export const SECONDARY_CERTIFIER = 'secondary_certifier';
export const REVIEW_AND_SUBMIT_COMPLETED = 'review_and_submit_completed';
export const REVIEW_AND_SUBMIT_NOT_COMPLETED =
  'review_and_submit_not_completed';
export const REVIEW_AND_SUBMIT_STEP_1 = 'review_and_submit_step_1';
export const REVIEW_AND_SUBMIT_STEP_2 = 'review_and_submit_step_2';
export const REVIEW_AND_SUBMIT_SIGNATURE = 'review_and_submit_signature';
export const REVIEW_AND_SUBMIT_COMMENT = 'review_and_submit_comment';
export const BUTTON_SIZES = ['small', 'medium', 'large'];
export const DEFAULT_LOCK_MESSAGE = 'Locked by User';

export const TITLE = {
  [PRIMARY_CERTIFIER]: {
    [REVIEW_AND_SUBMIT_COMPLETED]: {
      [REVIEW_AND_SUBMIT_COMMENT]: {
        [REVIEW_AND_SUBMIT_STEP_1]: 'Review and Submit Your Certification',
        [REVIEW_AND_SUBMIT_STEP_2]: 'Review and Submit Your Certification',
      },
      [REVIEW_AND_SUBMIT_SIGNATURE]: {
        [REVIEW_AND_SUBMIT_STEP_1]: 'Review and Submit Your Certification',
        [REVIEW_AND_SUBMIT_STEP_2]: 'Review and Submit Your Certification',
      },
    },
    [REVIEW_AND_SUBMIT_NOT_COMPLETED]: {
      [REVIEW_AND_SUBMIT_COMMENT]: {
        [REVIEW_AND_SUBMIT_STEP_1]: 'Your Certification Is Incomplete',
      },
      [REVIEW_AND_SUBMIT_SIGNATURE]: {
        [REVIEW_AND_SUBMIT_STEP_1]: 'Your Certification Is Incomplete',
      },
    },
  },
  [SECONDARY_CERTIFIER]: {
    [REVIEW_AND_SUBMIT_COMPLETED]: {
      [REVIEW_AND_SUBMIT_COMMENT]: {
        [REVIEW_AND_SUBMIT_STEP_1]: 'Complete Your Certification',
        [REVIEW_AND_SUBMIT_STEP_2]: 'Complete Your Certification',
      },
      [REVIEW_AND_SUBMIT_SIGNATURE]: {
        [REVIEW_AND_SUBMIT_STEP_1]: 'Complete Your Certification',
        [REVIEW_AND_SUBMIT_STEP_2]: 'Complete Your Certification',
      },
    },
    [REVIEW_AND_SUBMIT_NOT_COMPLETED]: {
      [REVIEW_AND_SUBMIT_COMMENT]: {
        [REVIEW_AND_SUBMIT_STEP_1]: 'Complete Your Certification',
        [REVIEW_AND_SUBMIT_STEP_2]: 'Complete Your Certification',
      },
      [REVIEW_AND_SUBMIT_SIGNATURE]: {
        [REVIEW_AND_SUBMIT_STEP_1]: 'Complete Your Certification',
        [REVIEW_AND_SUBMIT_STEP_2]: 'Complete Your Certification',
      },
    },
  },
};

export const SUBTITLE = {
  [PRIMARY_CERTIFIER]: {
    [REVIEW_AND_SUBMIT_COMPLETED]: {
      [REVIEW_AND_SUBMIT_COMMENT]: {
        [REVIEW_AND_SUBMIT_STEP_1]: 'Step 1 of 2',
        [REVIEW_AND_SUBMIT_STEP_2]: 'Step 2 of 2',
      },
      [REVIEW_AND_SUBMIT_SIGNATURE]: {
        [REVIEW_AND_SUBMIT_STEP_1]: 'Step 1 of 2',
        [REVIEW_AND_SUBMIT_STEP_2]: 'Step 2 of 2',
      },
    },
    [REVIEW_AND_SUBMIT_NOT_COMPLETED]: {
      [REVIEW_AND_SUBMIT_COMMENT]: {
        [REVIEW_AND_SUBMIT_STEP_1]:
          'You still have {reviewinfo} before your certification can be submitted.',
        [REVIEW_AND_SUBMIT_STEP_2]:
          'You still have {reviewinfo} before your certification can be submitted.',
      },
      [REVIEW_AND_SUBMIT_SIGNATURE]: {
        [REVIEW_AND_SUBMIT_STEP_1]:
          'You still have {reviewinfo} before your certification can be submitted.',
        [REVIEW_AND_SUBMIT_STEP_2]:
          'You still have {reviewinfo} before your certification can be submitted.',
      },
    },
  },
  [SECONDARY_CERTIFIER]: {
    [REVIEW_AND_SUBMIT_COMPLETED]: {
      [REVIEW_AND_SUBMIT_COMMENT]: {
        [REVIEW_AND_SUBMIT_STEP_1]:
          "Review the items you've certified, and send them to the primary certifier {name} who'll complete and submit the certification.",
        [REVIEW_AND_SUBMIT_STEP_2]:
          "Review the items you've certified, and send them to the primary certifier {name} who'll complete and submit the certification.",
      },
      [REVIEW_AND_SUBMIT_SIGNATURE]: {
        [REVIEW_AND_SUBMIT_STEP_1]:
          "Review the items you've certified, and send them to the primary certifier {name} who'll complete and submit the certification.",
        [REVIEW_AND_SUBMIT_STEP_2]:
          "Review the items you've certified, and send them to the primary certifier {name} who'll complete and submit the certification.",
      },
    },
    [REVIEW_AND_SUBMIT_NOT_COMPLETED]: {
      [REVIEW_AND_SUBMIT_COMMENT]: {
        [REVIEW_AND_SUBMIT_STEP_1]:
          "Review the items you've certified, and send them to the primary certifier {name} who'll complete and submit the certification.",
        [REVIEW_AND_SUBMIT_STEP_2]:
          "Review the items you've certified, and send them to the primary certifier {name} who'll complete and submit the certification.",
      },
      [REVIEW_AND_SUBMIT_SIGNATURE]: {
        [REVIEW_AND_SUBMIT_STEP_1]:
          "Review the items you've certified, and send them to the primary certifier {name} who'll complete and submit the certification.",
        [REVIEW_AND_SUBMIT_STEP_2]:
          "Review the items you've certified, and send them to the primary certifier {name} who'll complete and submit the certification.",
      },
    },
  },
};
